import { TEntityUntagged } from '@obvious.tech/constellation/Entity'

import { TEntityOverride } from 'src/types'
import StatusInput from 'src/components/flow/StatusInput'

import Flow from '../../../adminPanel/Flow'
import ListBulkActions from './Actions/ListBulkActions'
import EditDiagramToolbar from './Actions/EditDiagramToolbar'
import CreateDiagram from './Actions/CreateDiagram'

const override: TEntityOverride<TEntityUntagged<'Diagram'>> = {
  titleField: 'name',
  global: {
    properties: {
      id: {
        displayedName: 'ID',
      },
      createdAt: {
        hidden: true,
      },
      data: {
        hidden: true,
      },
      groups: {
        displayedName: 'Owners',
        type: 'groups',
      },
      author: {
        displayedName: 'Author',
        type: 'object',
        reference: {
          target: 'Passport',
          idKeyPath: 'passportId',
          labelKeyPath: 'userName',
          targetLabelKeyPath: 'username',
        },
        readOnly: true,
      },
      status: {
        displayedName: 'Status',
      },
      lastUpdate: {
        displayedName: 'Modified',
      },
      events: {
        displayedName: 'Triggers',
      },
      name: {
        displayedName: 'Name',
      },
    },
  },
  list: {
    displayedListToolbar: ListBulkActions,
    properties: {
      status: {
        type: 'DiagramStatus',
      },
    },
  },
  create: {
    displayedComponent: CreateDiagram,
    properties: {
      id: {
        hidden: true,
      },
      data: {
        hidden: true,
      },
      lastUpdate: {
        hidden: true,
      },
      events: {
        hidden: true,
      },
      status: {
        displayedComponent: StatusInput,
        defaultValue: 'stopped',
      },
    },
  },
  edit: {
    displayedComponent: Flow,
    displayedFormToolbar: EditDiagramToolbar,
    properties: {
      events: {
        hidden: true,
      },
      lastUpdate: {
        hidden: true,
      },
      status: {
        displayedComponent: StatusInput,
      },
    },
  },
}

export default override
